import { render, staticRenderFns } from "./DomainSettings.vue?vue&type=template&id=4e4cd493&scoped=true"
import script from "./DomainSettings.vue?vue&type=script&lang=js"
export * from "./DomainSettings.vue?vue&type=script&lang=js"
import style0 from "./DomainSettings.vue?vue&type=style&index=0&id=4e4cd493&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4cd493",
  null
  
)

export default component.exports